import { useSearchParams } from 'next/navigation'
import { useCallback } from 'react'

const usePostLoginRedirect = () => {
  const searchParams = useSearchParams()

  const getDestinationParam = useCallback(
    (encoded = false) => {
      const destinationRoute = searchParams?.get('destination')
      let route = destinationRoute || '/'

      route = encoded ? encodeURIComponent(route) : decodeURIComponent(`${route}`)

      return route
    },
    [searchParams],
  )

  const redirect = useCallback(() => {
    const redirectUrl = new URL(getDestinationParam(), window.location.origin)

    window.location.replace(redirectUrl.href)
  }, [getDestinationParam])

  return { getDestinationParam, redirect }
}

export default usePostLoginRedirect
